export const TOGGLE_GIFT_CARD = "TOGGLE_GIFT_CARD"
export const TOGGLE_GIFT_CARD_PENDING = "TOGGLE_GIFT_CARD_PENDING"
export const TOGGLE_GIFT_CARD_FULFILLED = "TOGGLE_GIFT_CARD_FULFILLED"
export const TOGGLE_GIFT_CARD_FAILED = "TOGGLE_GIFT_CARD_REJECTED"